import { IconButton, Typography } from '@mui/material';
import { FormInput } from '@/components/FormInput';
import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import { InfoModal } from '@/commons/info-modal';
import { Control, FieldErrors } from 'react-hook-form';
import { CreateAdFormData } from '@/pages/ad-pages/CreateAd';
import { Card } from '@/features/card';

type BasicInfoSectionProps = {
  control: Control<CreateAdFormData>;
  errors: FieldErrors<CreateAdFormData>;
};

export const BasicInfoSection: FC<BasicInfoSectionProps> = ({
  control,
  errors,
}) => {
  const { t } = useTranslation();
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  return (
    <section className="flex-1">
      <Typography variant="h6" sx={{ mb: '8px' }}>
        <Trans i18nKey="basic_info_section.title" />
        <IconButton size="medium" onClick={() => setInfoModalOpen(true)}>
          <InfoIcon fontSize="inherit" />
        </IconButton>
      </Typography>

      <Card>
        <div className="mt-1">
          <FormInput
            name="title"
            label={t('basic_info_section.title_field.label')}
            control={control}
            error={!!errors.title}
            fullWidth={true}
            helperText={errors.title?.message?.toString() || ''}
            rules={{ required: t('create_ad.form.title.required') }}
          />
        </div>
      </Card>

      <InfoModal
        title={t('basic_info_section.title')}
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
      >
        <Trans i18nKey="basic_info_section.info" />
      </InfoModal>
    </section>
  );
};
